import moment from 'moment-timezone';

/**
 * Check if documents should be hidden for an order
 * Documents are hidden if the appointment date/time is more than 3 days ago
 * @param order - Order object with appointment date/time information
 * @returns true if documents should be hidden, false otherwise
 */
export const shouldHideDocuments = (order: any): boolean => {
  if (!order.w_Appointment_Date) {
    return false; // If no appointment date, show documents
  }

  const now = moment().tz('America/Los_Angeles');
  let appointmentDateTime: moment.Moment;

  // Parse appointment date in Los Angeles timezone (format: MM/DD/YYYY)
  const appointmentDate = moment.tz(order.w_Appointment_Date, 'MM/DD/YYYY', 'America/Los_Angeles');

  // Handle Open Time appointments or missing time
  if (order.w_Appointment_Time_type === 'OT' || !order.w_Appointment_Time || order.w_Appointment_Time === '') {
    // For Open Time, use start of day (00:00:00)
    appointmentDateTime = appointmentDate.startOf('day');
  } else {
    // Parse appointment time (format: hh:mm A) - time is already in local timezone context
    const appointmentTime = moment(order.w_Appointment_Time, 'hh:mm A');
    // Combine date and time in Los Angeles timezone
    appointmentDateTime = appointmentDate
      .hour(appointmentTime.hour())
      .minute(appointmentTime.minute())
      .second(0)
      .millisecond(0);
  }

  // Check if more than 3 days have passed
  const daysDiff = now.diff(appointmentDateTime, 'days');
  return daysDiff > 3;
};

